var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 71,
    viewBox: "0 0 54 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.595703 6.19841V64.8016C0.595703 68.2249 3.32746 71 6.69727 71H47.7441C51.1139 71 53.8457 68.2249 53.8457 64.8016V16.3106C53.8457 14.6549 53.1936 13.068 52.0348 11.9037L41.9706 1.79145C40.8283 0.643726 39.2865 0 37.6799 0H6.69727C3.32747 0 0.595703 2.77512 0.595703 6.19841ZM4.47852 64.8016V6.19841C4.47852 4.95358 5.47188 3.94444 6.69727 3.94444H36.9277V17.4683C36.9277 19.8023 38.7903 21.6944 41.0879 21.6944H49.9629V64.8016C49.9629 66.0464 48.9695 67.0556 47.7441 67.0556H6.69727C5.47188 67.0556 4.47852 66.0464 4.47852 64.8016ZM49.9629 17.75V16.3106C49.9629 15.7085 49.7258 15.1315 49.3044 14.7081L40.8105 6.17377V17.4683C40.8105 17.6239 40.9347 17.75 41.0879 17.75H49.9629Z",
    fill: "#9D9C9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4707 28.8438C9.4707 27.1797 10.0254 26.625 11.6895 26.625H42.752C44.416 26.625 44.9707 27.1797 44.9707 28.8438C44.9707 30.5078 44.416 31.0625 42.752 31.0625H11.6895C10.0254 31.0625 9.4707 30.5078 9.4707 28.8438Z",
    fill: "#C9C7C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4707 37.7188C9.4707 36.0547 10.0254 35.5 11.6895 35.5H42.752C44.416 35.5 44.9707 36.0547 44.9707 37.7188C44.9707 39.3828 44.416 39.9375 42.752 39.9375H11.6895C10.0254 39.9375 9.4707 39.3828 9.4707 37.7188Z",
    fill: "#C9C7C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4707 46.5938C9.4707 44.9297 10.0254 44.375 11.6895 44.375H42.752C44.416 44.375 44.9707 44.9297 44.9707 46.5938C44.9707 48.2578 44.416 48.8125 42.752 48.8125H11.6895C10.0254 48.8125 9.4707 48.2578 9.4707 46.5938Z",
    fill: "#C9C7C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4707 55.4688C9.4707 53.8047 10.0254 53.25 11.6895 53.25H42.752C44.416 53.25 44.9707 53.8047 44.9707 55.4688C44.9707 57.1328 44.416 57.6875 42.752 57.6875H11.6895C10.0254 57.6875 9.4707 57.1328 9.4707 55.4688Z",
    fill: "#C9C7C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocText);
export default __webpack_public_path__ + "static/media/doc-text.0c4d89cd0bdec04d4aafa0abb6893c72.svg";
export { ForwardRef as ReactComponent };